import { render, staticRenderFns } from "./InsumoWizard.vue?vue&type=template&id=7af87fa2&scoped=true"
import script from "./InsumoWizard.vue?vue&type=script&lang=js"
export * from "./InsumoWizard.vue?vue&type=script&lang=js"
import style0 from "./InsumoWizard.vue?vue&type=style&index=0&id=7af87fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af87fa2",
  null
  
)

export default component.exports